<template lang="html">
  <v-container grid-list-md align-center justify-center pt-0 pl-0 pr-0 pb-0>
    <ComponentPlantCompanyStatic @activeMenu="activeMenu"/>
  </v-container>
</template>

<script>
import ComponentPlantCompanyStatic from '@/components/ComponentPlantCompanyStatic';
export default {
  components: {
    ComponentPlantCompanyStatic,
  },
  data(){
    return{
      active: ''
    }
  },
  methods:{
    gotoLink(link){
      this.$router.push(link)
    },
    activeMenu(status){
      this.$emit('activeMenu', status)
    }
  }
}
</script>
